exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".plagin-wrapper[data-v-7b6a433a]{-webkit-box-sizing:border-box;box-sizing:border-box;width:100vw;height:calc(100vh - 63px);overflow:hidden}.plagin-wrapper img[data-v-7b6a433a]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center;cursor:pointer}@media screen and (min-width:64em){.plagin-wrapper[data-v-7b6a433a]{height:100vh}}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.plagin-wrapper .image__fit[data-v-7b6a433a]{width:100%;height:auto;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}}", ""]);

// exports
